<div class="wizzard-collapse-page" [ngClass]="{'is-valid':  isPageValid$ | async}">
    <div class="wizzard-collapse-page__inner" directive-menu-flow-page [pageIdentifier]="menuFlowPage.PageIdentifier"
        [isExpanded]="isExpanded">

        <ng-template #left>
            <ng-container [ngSwitch]="true">

                <ng-container *ngSwitchCase="hasErrors$ | async">
                    <shared-indicator [size]="badgeSize" feel="negative-full">!</shared-indicator>
                </ng-container>

                <ng-container *ngSwitchCase="markAsComplete$ | async">
                    <shared-indicator [size]="badgeSize" feel="positive-full" icon="checkmark"></shared-indicator>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <shared-badge [size]="badgeSize">{{index + 1}}</shared-badge>
                </ng-container>

            </ng-container>

        </ng-template>

        <ng-template #right>
            <shared-circle-btn *ngIf="isFixedOpen !== true" (onClick)="toggleCollapse()"
                [icon]="isExpanded ? 'up': 'down'" feel="transparent" [hoverShadow]="false">
            </shared-circle-btn>
        </ng-template>

        <shared-wizzard-header [paddingTop]="headerPaddingTop" [paddingBottom]="headerPaddingBottom" marginTop="none"
            marginBottom="none" class="wizzard-collapse-page__hd" [postContent]="(headerSuffixTitle$ | async)"
            [left]="left" [right]="right">
            {{headerPrefixTitle$ | async}}
        </shared-wizzard-header>

        <div class="wizzard-collapse-page__bd" [hidden]="!isExpanded && !isFixedOpen">
            <shared-list-for-wizzard-products class="wizzard-collapse-page__products-list" [menuFlowPage]="menuFlowPage"
                [menuFlowProducts]="menuFlowPage.Products"></shared-list-for-wizzard-products>
        </div>

    </div>
</div>
